import { render, staticRenderFns } from "./JsonViewer.vue?vue&type=template&id=3458ab03&"
import script from "./JsonViewer.vue?vue&type=script&lang=js&"
export * from "./JsonViewer.vue?vue&type=script&lang=js&"
import style0 from "./JsonViewer.vue?vue&type=style&index=0&id=3458ab03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports